import { React, useState } from "react";
import classes from './Conflict.module.scss';
import GEST_API from "../../../Api/GESTApi";

//MUI Imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

function Conflict({ conflictState, onResolution, project}) {
    
    const [isSaving, setIsSaving] = useState(false)

    function onConflictResolutionChoice(action){

        switch (action) {
          case "push":
            //Push current changes and overwrite whats stored
            setIsSaving(true)
            GEST_API.IN_CONFLICT = false;
            GEST_API.SAVE_PROJECT(project, true).then((response) => {
                onResolution("pushed", response.payload.project.lastUpdateTimestamp);
                setIsSaving(false)
            }).catch((error) => {
                setIsSaving(false)
            });
            break;
          default:
            onResolution("pull", null);
            break;
        }
    
      }

    if(conflictState){
        return (
            <Box className={classes.Conflict}>
                <div className={classes.Conflict__message_container}>
                    <h2>Your copy is out of date</h2>
                    <p>Do you want to overwrite with the changes you have made?</p>
                    {(
                        !isSaving
                    ?
                    <div className={`inline_button inline_button__small ${classes.Conflict__button}`}>
                        <Button variant="contained"
                            onClick={() => {onConflictResolutionChoice("pull")}}
                        >
                            No, replace mine with the latest version
                        </Button>
                        <Button variant="contained"
                            onClick={() => {onConflictResolutionChoice("push")}}
                        >
                            Yes, replace the online version with mine
                        </Button>
                    </div>
                    :
                    <>
                        <h2>Saving</h2>
                    </>
                    )}
                </div>
            </Box>
        );

    }else{
        return ("")
    }
}
export default Conflict